import { useTranslation } from 'react-i18next';

import { useBrandInfo } from '~/hooks/useBrandInfo';
import EmptyStateCard from '~/Nova/scenes/HostingList/components/EmptyStateCard';
import HowtoCard from '~/Nova/scenes/Site/components/HowtoCard';

const NoHostingPackageCard = ({
  showHowToCard = false,
}: {
  showHowToCard?: boolean;
}) => {
  const { t } = useTranslation('hosting');
  const { brandFromJWT, marketPlaceUrl, howToHostingArticleUrl } =
    useBrandInfo();
  const isHostgator = brandFromJWT?.toLowerCase() === 'hostgator';

  return (
    <>
      <EmptyStateCard
        title={t('hostingNova.emptyState.title')}
        description={t('hostingNova.emptyState.description')}
        buttonLabel={t('hostingNova.emptyState.buttonLabel')}
        buttonLink={marketPlaceUrl}
      />
      {showHowToCard && (
        <HowtoCard
          title={isHostgator ? 'hosting.hostgator.title' : 'hosting.title'}
          description={
            isHostgator
              ? 'hosting.hostgator.description'
              : 'hosting.description'
          }
          displayVideoArticleCard={false}
          articleUrl={howToHostingArticleUrl}
        />
      )}
    </>
  );
};

export default NoHostingPackageCard;
